import { render, staticRenderFns } from "./LayananSuperiorLayanan.vue?vue&type=template&id=7f5e76d5"
import script from "./LayananSuperiorLayanan.vue?vue&type=script&setup=true&lang=js"
export * from "./LayananSuperiorLayanan.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports